export default __webpack_public_path__ + "522e008b00a2a568ed6556497798d8b4.svg";